import { SelectDropdown } from "@prosolve/common-components-ui";
import OptionalFormFieldWrapper from "./OptionalFormFieldWrapper";
import useIsMobileView from "../../hooks/useIsMobileView";

export default function ProbabilityDropdown({
  probability: defaultProbability,
  onChange
}) {
  const isMobileView = useIsMobileView();

  const options = [
    { value: '100', text: '100%' },
    { value: '70', text: '>= 70%' }
  ]

  return (
    <div style={{ display: 'flex', flexDirection: 'column'}}>
      <OptionalFormFieldWrapper isEnabled={true} label={'Probability'}></OptionalFormFieldWrapper>
      <SelectDropdown
        options={options}
        value={defaultProbability}
        onChange={onChange}
        width='200px'
        isMobileView={isMobileView}
      />
    </div>
  )
}